import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/FilePlus.es.js";
const o = e.forwardRef((r, s) => /* @__PURE__ */ e.createElement(t, { ref: s, ...r, weights: a }));
o.displayName = "FilePlusIcon";
const m = o;
export {
  m as FilePlus,
  o as FilePlusIcon
};
